module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Thin.199b6f2.eot";